export function formatPhoneNumber (str:string, separator?:string):string {
  if (typeof separator !== 'string') {
    separator = ' ';
  }

  const cleanStr = str.replace(/[^0-9+]/g, '');
  if (/^\d{10}$/.test(cleanStr)) {
    return cleanStr.match(/../g).join(separator);
  } else if (/^\+\d{11}/.test(cleanStr)) {
    return cleanStr.slice(0, 3) + ' ' + cleanStr.slice(3, 4) + separator + cleanStr.slice(4, 13).match(/../g).join(separator);
  } else {
    throw new Error('Numero de téléphone non reconnu : ' + str);
  }
}
